<template>
	<div class="gvf">
		<v-tooltip
			top
			:open-on-click="true"
			:open-on-focus="true"
			:open-on-hover="true"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-chip v-bind="attrs" v-on="on">
					<v-icon color="primary">mdi-alert</v-icon>
					{{ gridViewField.Label }} : {{ value }}
				</v-chip>
			</template>
			Value automatically generated
		</v-tooltip>
	</div>
</template>
<script>
import gridFieldMixin from '../../../../mixins/grids/gridFieldMixin';
import projectSettingsMixin from '../../../../mixins/projectSettingsMixin';
import moment from 'moment';

export default {
	name: 'AutoGeneratedField',
	mixins: [gridFieldMixin, projectSettingsMixin],
	data() {
		return {
			value: null,
			textFieldRule: [
				() => {
					return 'Value automatically generated';
				},
			],
		};
	},
	mounted() {
		if (this.record && this.key && this.record[this.key]) {
			if (moment(this.record[this.key], moment.ISO_8601, true).isValid())
				this.value = this.getDateTimeFormat(this.record[this.key]);
			else this.value = this.record[this.key];
		}
	},
};
</script>
